import React from 'react';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useNavigate } from 'react-router';
import EventListItem from '../EventListItem';
import { useBreadcrumbs } from '../../../common/Context';
import ObjectVtpDescription from '../../../fedance-ui/ObjectVtpDescription';
import { useUserContext } from 'fennec-ui';
import { UserName } from '../../../common/User';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

var _ = require('lodash');

export function ContextLocaladminElement(props) {
    const navigate = useNavigate()
    const { item, color } = props;

    return (<a href={`/app/local/${item.ID}`}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: color }}></i>
        </div>
        <div className='element-wrapper'>
            <div className='element-content'>
                <div className='element-content-body' >
                    {item?.nazvanie}
                </div>
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.dataVstupleniya && <div>Дата регистрации: {dayjs(item?.dataVstupleniya).format("DD.MM.YYYY HH:mm")}</div>}
            </div>
        </div>
    </div></a>)
}

export function ContextSchoolElement(props) {
    const navigate = useNavigate()
    const { item, color } = props;
    return (<a href={`/app/school/${item.ID}`}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: color }}></i>
        </div>
        <div className='element-wrapper'>
            <div className='element-content'>
                <div className='element-content-body' >
                    {item?.nazvanieShkoliTantsev}
                </div>
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.dataRegistratsii && <div>Дата регистрации: {dayjs(item?.dataRegistratsii).format("DD.MM.YYYY HH:mm")}</div>}
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                <div>Региональное отделение:
                    <span style={{ fontStyle: "italic" }}> {item?.regionalnoeOtdelenie?.nazvanie}</span>
                </div>
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.vseTipiPolzovatelei?.filter(e => e?.tipPolzovatelyaID == 18)?.map(e => {
                    return (<div>Владелец:
                        <span style={{ fontStyle: "italic" }}> {e?.user?.lastname} {e?.user?.firstname}</span>
                    </div>)
                })}
            </div>
        </div>
    </div></a>)
}

export function ContextOrganizerElement(props) {
    const navigate = useNavigate()
    const { item, color } = props;
    return (<a href={`/app/organizer/${item.ID}`}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: color }}></i>
        </div>
        <div className='element-wrapper'>
            <div className='element-content'>
                <div className='element-content-body' >
                    {item?.nazvanie}
                </div>
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.dataRegistratsii && <div>Дата регистрации: {dayjs(item?.dataRegistratsii).format("DD.MM.YYYY HH:mm")}</div>}
            </div>
        </div>
    </div></a>)
}

export function ContextTeacherElement(props) {
    const navigate = useNavigate()
    const user = useUserContext();
    const { item, color } = props;
    return (<a href={`/app/teacher/${item.ID}`}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: (item?.user?.ID === user?.ID)?color:"grey" }}></i>
        </div>
        <div className='element-wrapper'>
            <div className='element-content'>
                <div className='element-content-body' >
                    {item?.regionalnoeOtdelenie?.nazvanie}
                </div>
                {(item?.user?.ID != user?.ID) && <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                    <UserName item={item?.user} noborder={true} noicon={true} />
                </div>}
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.dataRegistratsii && <div>Дата регистрации: {dayjs(item?.dataRegistratsii).format("DD.MM.YYYY HH:mm")}</div>}
            </div>
        </div>
    </div></a>)
}


export function ContextTestingElement(props) {
    const { item, color } = props;
    return (<a href={`/app/testing/${item.ID}`}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: color }}></i>
        </div>
        <div className='element-wrapper' style={{
            backgroundColor: (item?.passed)?"#dcf5e6":"transparent",
            padding: "3px 7px",
            borderRadius: "5px"
        }}>
            <div className='element-content'>
                <div className='element-content-body'>
                    {item?.kategoriyaSudeistva?.nazvanieKategorii+" - "+
                    item?.kategoriyaSudeistva?.tanets.nazvanie}
                </div>
                {item?.certificateNumber && <div style={{ fontSize: "12px", fontStyle: "italic" }}>Сертификат: {item?.certificateNumber}</div>}
            </div>
            <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                <div>
                    <div>
                        {item?.CreatedAt && <div>Дата создания: {dayjs(item?.CreatedAt).format("DD.MM.YYYY HH:mm")} {(item?.done) ? "(завершен)" : ""}</div>}
                    </div>
                    {item?.done && <div>
                        {/* Тест {(item?.nabranniiProtsent >= item?.prokhodnoiProtsent) ? "пройден!" : "не пройден."} Результат: <span style={{ color: (item?.nabranniiProtsent >= item?.prokhodnoiProtsent) ? "green" : "red" }}>{item?.nabranniiProtsent}%</span> */}
                        Тест {(item?.nabranniiProtsent >= item?.prokhodnoiProtsent && item?.countErrorProtocoli <= item?.dopustimoeKolvoOshibokProtokolov) ? "пройден!" : "не пройден."} Результат: <span style={{ color: (item?.nabranniiProtsent >= item?.prokhodnoiProtsent) ? "green" : "red" }}>{item?.nabranniiProtsent}%</span>, набрано {item?.summaBallov} баллов из {item?.vsegoBallovVTeste}{(item?.vsegoProtokolov > 0)?(item?.nepravilnieProtokli != 0)?<span>, <span style={{ color: "red" }}>есть неправильные протоколы</span></span>:<span>, <span style={{ color: "green" }}>протоколы корректны</span></span>:""} 
                    </div>}
                </div>
            </div>
        </div>
    </div></a>)
}

export function ContextGetpromoElement(props) {
    const { item, color } = props;
    const navigate = useNavigate()
    return (<div onClick={()=>{navigate(`/app/getpromo/${item.ID}`)}}><div key={item?.ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
        {/* <div className='element-slot'>
            <i className="fa fa-circle" style={{ fontSize: "8px", color: color }}></i>
        </div> */}
        <div className='element-wrapper'>
            <div className='element-content'>
                <div className='element-content-body'>
                    {/* {item?.nazvanieMeropriyatiya} - {dayjs(item?.nachaloSorevnovaniya).format("DD.MM.YYYY")},  {_.get(item, "mestoProvedeniya.name")} */}
                    {/* <span>{item?.nazvanieMeropriyatiya}</span> - {dayjs(item?.nachaloSorevnovaniya).format("DD.MM.YYYY")} {(item?.mestoProvedeniya)? "("+item?.mestoProvedeniya?.name+")":""} */}
                    <EventListItem
                        key={"event"}
                        event={item}
                        hideRoles={true}
                        size="small"
                        hidePreview={true}
                        noNameLink={true}
                        hideBuyButton={true}
                        extButtons={({ path, size, style }) => [
                            <div key="view">
                                <div
                                    style={style}
                                    className={`btn btn-soft-secondary btn-sm`}
                                    onClick={()=>{navigate(`${path(1)}/${item.ID}`)}}
                                >
                                    Промокод
                                </div>
                            </div>
                        ]}
                    />
                </div>
            </div>
            {/* <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                {item?.CreatedAt && <div>Дата создания: {dayjs(item?.CreatedAt).format("DD.MM.YYYY HH:mm")}</div>}
            </div> */}
        </div>
    </div></div>)
}

export function ContextRoleElement(props) {
    const { item, color } = props;

    const navigate = useNavigate()
    const x = useBreadcrumbs()
    let path = "/app" + x.map(o => `/${o.uuid}`).join("");

    let vtp = _.get(item, "_role");
    let ID = _.get(item, "_role.ID");

    return (<div key={ID} onClick={()=>{navigate(`${path}/${ID}`)}}>
        <div key={ID} className='element bg bg-fwhite pointer' style={{ textAlign: "left", padding: "3px 0" }}>
            <div className='element-slot'>
                <i className="fa fa-circle" style={{ fontSize: "8px", color: color }}></i>
            </div>
            <div className='element-wrapper'>
                <div className='element-content'>
                    <div className='element-content-body'>
                        <div style={{color:"var(--bs-link-color)"}}>
                            <ObjectVtpDescription object={vtp} inline={true} alt={item} />
                        </div>
                        {vtp && <div style={{
                            fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)", textAlign: "left", textWrap: "nowrap",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}>{vtp?.tipPolzovatelya?.opisanie}</div>}
                    </div>
                </div>
                <div className='element-footer' style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                    {item?.CreatedAt && <div>Дата создания: {dayjs(item?.CreatedAt).format("DD.MM.YYYY HH:mm")}</div>}
                </div>
            </div>
        </div>
    </div>)
}